import { motion, MotionProps } from "framer-motion";
import { ElementType, ReactNode } from "react";

interface FadeInComponentProps {
  className?: string;
  children: ReactNode;
  id?: string;
  delay?: number;
  as?: ElementType;
  initial?: MotionProps["initial"];
  whileInView?: MotionProps["whileInView"];
  transition?: MotionProps["transition"];
  viewport?: MotionProps["viewport"];
}

function FadeInComponent({
  children,
  as: Tag = "div",
  id,
  delay = 0,
  className,
  initial = { opacity: 0, y: 30 },
  whileInView = { opacity: 1, y: 0 },
  transition = { duration: 1, ease: "easeOut", delay },
  viewport = { once: true, amount: 0.2 },
}: FadeInComponentProps) {
  const MotionTag = motion.create(Tag);

  return (
    <MotionTag
      id={id}
      className={className}
      initial={initial}
      whileInView={whileInView}
      transition={transition}
      viewport={viewport}
    >
      {children}
    </MotionTag>
  );
}

export default FadeInComponent;